import { ProductItem } from 'src/types/common/product';
export const generateProductSetItem = (product: ProductItem) => {
  const { defaultSalePrice, uuid } = product || {};
  return {
    product: product,
    noOfUnit: 1,
    unitPrice: defaultSalePrice,
    uuid: uuid,
  };
};
